// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Production48Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Production48: FC<Production48Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path
                d="m21.087 41-.414-3.277a4.001 4.001 0 0 0-2.024-2.992l-.768-.428-.675-.392a4.03 4.03 0 0 0-3.57-.235l-3.122 1.298-2.883-4.928 2.661-1.995c1-.75 1.602-1.93 1.602-3.197v-1.708a3.996 3.996 0 0 0-1.602-3.197l-2.661-1.995 2.883-4.928 3.143 1.307a4.03 4.03 0 0 0 3.449-.168c.282-.151.54-.291.853-.472l.034-.02c.174-.1.23-.133.308-.18l.036-.021c.06-.036.154-.093.403-.24a4.002 4.002 0 0 0 1.931-2.94L21.087 7h5.826l.414 3.279a4.012 4.012 0 0 0 1.98 2.97c.2.116.414.242.574.34.309.19.727.42 1.003.57a4.014 4.014 0 0 0 3.455.175l3.147-1.308 2.883 4.928-2.683 2.011a3.99 3.99 0 0 0-1.597 3.04 35.811 35.811 0 0 0-.033 1.484v.365c0 1.268.602 2.448 1.601 3.197l2.662 1.995-2.88 4.921-3.077-1.29a4.031 4.031 0 0 0-3.519.196 971.841 971.841 0 0 1-.918.512l-.64.373a4 4 0 0 0-1.957 2.953L26.913 41h-5.826Zm-2.755 2.123c.063.501.495.877 1.007.877h9.321a1.01 1.01 0 0 0 1.008-.877l.636-5.036a1 1 0 0 1 .49-.737l.641-.373.02-.01.848-.474c.275-.153.608-.172.899-.05l4.672 1.96a1.023 1.023 0 0 0 1.278-.421l4.662-7.97a.99.99 0 0 0-.265-1.295l-4.093-3.067a.995.995 0 0 1-.4-.796v-.365c0-.185 0-.547.031-1.37a.99.99 0 0 1 .398-.753l4.114-3.083a.99.99 0 0 0 .265-1.295l-4.663-7.972a1.023 1.023 0 0 0-1.275-.422l-4.739 1.97a1.014 1.014 0 0 1-.872-.042 21.03 21.03 0 0 1-.861-.488c-.197-.121-.441-.264-.648-.383a1.013 1.013 0 0 1-.503-.748l-.635-5.026A1.01 1.01 0 0 0 28.66 4h-9.32a1.01 1.01 0 0 0-1.008.877l-.637 5.04a1.002 1.002 0 0 1-.485.734l-.417.249-.334.195c-.273.157-.5.28-.77.425a1.03 1.03 0 0 1-.88.043l-4.735-1.97a1.023 1.023 0 0 0-1.275.423l-4.663 7.972a.99.99 0 0 0 .265 1.295l4.092 3.067c.252.189.4.483.4.796v1.708a.995.995 0 0 1-.4.796l-4.092 3.067a.99.99 0 0 0-.265 1.295l4.663 7.972c.256.438.803.618 1.275.422l4.715-1.96a1.03 1.03 0 0 1 .91.06l.69.4.016.01.784.436c.28.156.468.433.508.747l.635 5.024Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
            <path
                d="M24 28a4 4 0 1 0 0-8 4 4 0 0 0 0 8Zm0 3a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Production48;
